import t from"@emotion/styled-base";import{Text as e}from"./Text";import{styles as o}from"./style";export var TextStyled=t(e,{target:"e1yhcai00"})(o);
//# sourceMappingURL=TextStyled.js.map